<template>
	<div>
		<!-- 不使用图片服务器 -->
		<template v-if="!isServer">
			<el-upload :show-file-list="false" :http-request="upload_file" :before-upload="upload_check" :accept="accept" :multiple="isMore">
				<template v-if="!isButton">
					<template v-if="isList">
						<div class="upload iconfont icon-upload"></div>
					</template>
					<template v-if="!isList">
						<div class="upload iconfont" :class="files ? '':'icon-upload'">
							<img :src="files" alt="" v-if="files">
						</div>
					</template>
				</template>
				<template v-if="isButton">
					<el-button type="primary">点击上传</el-button>
				</template>
			</el-upload>
		</template>

		<template v-if="isServer">
			<template v-if="!isButton">
				<template v-if="isList">
					<div class="upload iconfont icon-upload" @click="server_show(true)"></div>
				</template>
				<template v-if="!isList">
					<div class="upload iconfont" :class="files ? '':'icon-upload'" @click="server_show(true)">
						<img :src="files" alt="" v-if="files">
					</div>
				</template>
			</template>
			<template v-if="isButton">
				<el-button type="primary" @click="server_show(true)">点击上传</el-button>
			</template>
		</template>
		
		<div class="upload-list" v-if="isList">
			<div class="upload-item" v-for="(val,key) in files" :key="key">
				<img :src="val" alt="">
				<div class="upload-item-top">
					<div class="upload-item-left" @click="files_left(key)">◁</div>
					<div class="upload-item-right" @click="files_right(key)">▷</div>
				</div>
				<div class="upload-item-button">
					<div class="upload-item-view" @click="files_view(val)">预览</div>
					<div class="upload-item-del" @click="files_del(key)">删除</div>
				</div>
			</div>
		</div>
		<div class="upload-notice" v-if="notice">{{notice}}</div>
		
		<layer-pop title="上传/选择文件" @close="server_show(false)" v-if="is_server">
			<vue-upload-server :width="width" :height="height" :mix-width="mixWidth" :mix-height="mixHeight" :scale="scale" :max-width="maxWidth" :max-height="maxHeight" :max-size="maxSize" :is-more="isMore" :accept="accept" :server-type="serverType" @submit="server_upload_submit"></vue-upload-server>
		</layer-pop>
		
	</div>
</template>

<script>
	import LayerPop from "@/components/layer-pop";
	import VueUploadServer from "@/components/upload/upload-server";
	export default {
		name : "vue-upload",
		components : {VueUploadServer, LayerPop},
		model : { prop:'files' ,event:'change' },
		props : {
			files : {type : [String,Array], default : ''}, //上传文件列表
			isServer : { type : Boolean, default :  false}, //是否可选择服务器图片
			isList : {type : Boolean, default : false}, //是否是列表上传
			isMore : { type : Boolean, default :  false}, //是否可多先
			accept : {type : String, default : ''},//上传文件限制
			isButton : {type : Boolean, default : false},
			notice : {type : String, default : ''},
			mixWidth : {type : [String,Number], default:0},
			maxWidth : {type : [String,Number], default:0},
			mixHeight : {type : [String,Number], default:0},
			maxHeight : {type : [String,Number], default:0},
			width :  {type : [String,Number], default:0},
			height : {type : [String, Number], default : 0},
			scale : {type : String, default : ''},
			maxSize : {type : [String,Number], default : 0},
			serverType : {type : String, default : 'all'},
		},
		data (){
			return {
				is_server : false,
				dir : [],
			}
		},
		methods : {
			upload_check : function  (e){
				let that = this;
				let check_size = true;
				if (that.maxSize){
					let size = e.size / 1024;
					if (size > that.maxSize){
						that.$_showToastNone('最大只能上传' + that.maxSize + 'KB');
						check_size = false;
					}
				}

				let check_image = new Promise(function (resolve, reject){
					if (that.maxWidth || that.maxHeight || that.width || that.height || that.scale || that.minWidth || that.minHeight){
						let _url = window.URL || window.webkitURL;
						let image = new Image();
						image.onload = function (){
							//检查宽
							if (that.width){
								if (image.width != that.width){
									that.$_showToastNone('图片宽必须是' + that.width + 'px');
									reject();
								}
							}
							//检查高
							if (that.height){
								if (image.height != that.height){
									that.$_showToastNone('图片高必须是' + that.height + 'px');
									reject();
								}
							}
							//检查比例
							if (that.scale){
								let scale = that.scale.split('|');
								if ((image.width / image.height) != (scale[0] / scale[1])){
									that.$_showToastNone('图片宽高比例必须是' + scale[0] + ':' + scale[1]);
									reject();
								}
							}
							//最小宽
							if (that.minWidth){
								if (image.width < that.minWidth){
									that.$_showToastNone('图片最小宽必须是' + that.minWidth + 'px');
									reject();
								}
							}
							//最小高
							if (that.minHeight){
								if (image.height < that.minHeight){
									that.$_showToastNone('图片最小高必须是' + that.minHeight + 'px');
									reject();
								}
							}
							//最小宽
							if (that.maxWidth){
								if (image.width > that.maxWidth){
									that.$_showToastNone('图片最大宽必须是' + that.maxWidth + 'px');
									reject();
								}
							}
							//最小高
							if (that.maxHeight){
								if (image.height > that.maxHeight){
									that.$_showToastNone('图片最大高必须是' + that.maxHeight + 'px');
									reject();
								}
							}
							resolve();
						}
						image.src = _url.createObjectURL(e);
					}else{
						resolve();
					}
				})
				return check_size && check_image;
			},
			upload_file : async function (e){
				try{
					if (e.file){
						this.$_showLoading();
						let res = await this.$_api.upload(e.file, this.dir.join('/'));
						this.$_hideLoading();
						this.$_showToast(res.errmsg,res.style);
						if (this.isList){
							let list = this.files;
							list.push(res.url);
							this.files = list;
							this.$emit('change', this.files);
						}else{
							this.files = res.url;
							this.$emit('change', this.files);
						}
					}
				}catch (e){
					console.log(e);
					return false;
				}
			},
			server_show : function  (show){
				if (show){
					this.is_server = true;
				}else{
					this.is_server = false;
					this.list = [];
					this.dir = [];
				}
			},
			server_upload_submit : async function  (e){
				try{
					let that = this;
					this.is_server = false;
					if (this.isList){
						let list = this.files;
						e.map( async function  (val){
							let check = await that.server_upload_submit_check(val);
							if (check){
								list.push(val);
							}
						})
						this.files = list;
						this.$emit('change', this.files);
					}else{
						let check = await this.server_upload_submit_check(e);
						if (!check){
							return;
						}
						this.files = e;
						this.$emit('change', this.files);
					}
				}catch (e){
					console.log(e);
					return false;
				}
				
			},
			server_upload_submit_check : function  (e){
				let that = this;
				return  new Promise(function (resolve){
					if (that.maxWidth || that.maxHeight || that.width || that.height || that.scale || that.minWidth || that.minHeight){
						let image = new Image();
						image.onload = function (){
							//检查宽
							if (that.width){
								if (image.width != that.width){
									that.$_showToastNone('图片宽必须是' + that.width + 'px');
									resolve(false);
								}
							}
							//检查高
							if (that.height){
								if (image.height != that.height){
									that.$_showToastNone('图片高必须是' + that.height + 'px');
									resolve(false);
								}
							}
							//检查比例
							if (that.scale){
								let scale = that.scale.split('|');
								if ((image.width / image.height) != (scale[0] / scale[1])){
									that.$_showToastNone('图片宽高比例必须是' + scale[0] + ':' + scale[1]);
									resolve(false);
								}
							}
							//最小宽
							if (that.minWidth){
								if (image.width < that.minWidth){
									that.$_showToastNone('图片最小宽必须是' + that.minWidth + 'px');
									resolve(false);
								}
							}
							//最小高
							if (that.minHeight){
								if (image.height < that.minHeight){
									that.$_showToastNone('图片最小高必须是' + that.minHeight + 'px');
									resolve(false);
								}
							}
							//最小宽
							if (that.maxWidth){
								if (image.width > that.maxWidth){
									that.$_showToastNone('图片最大宽必须是' + that.maxWidth + 'px');
									resolve(false);
								}
							}
							//最小高
							if (that.maxHeight){
								if (image.height > that.maxHeight){
									that.$_showToastNone('图片最大高必须是' + that.maxHeight + 'px');
									resolve(false);
								}
							}
							resolve(true);
						}
						image.src = e;
					}else{
						resolve(true);
					}
				})
			},
			files_view : function  (url){
				if (url){
					window.open(url);
				}
			},
			files_del : function  (key){
				let files = this.files;
				files = this.$_tools.unset(files,key);
				this.files = files;
				this.$emit('change', this.files);
			},
			files_left : function  (key){
				let list = this.files;
				if (key==0){
					this.$_showToastNone('已最前');
					return;
				}
				let self = list[key];
				let prev = list[(key-1)];
				this.$set(this.files,key,prev);
				this.$set(this.files,(key-1),self);
				this.$emit('change', this.files);
			},
			files_right : function  (key){
				let list = this.files;
				if (key==(list.length-1)){
					this.$_showToastNone('已最后');
					return;
				}
				let self = list[key];
				let prev = list[(key+1)];
				this.$set(this.files,key,prev);
				this.$set(this.files,(key+1),self);
				this.$emit('change', this.files);
			},
		},
	}
</script>

<style scoped>
	.upload { width: 120px; height: 140px; border-radius: 5px; border: 1px solid #dcdfe6; overflow: hidden;
    line-height: 140px; text-align: center; font-size: 45px; color: #c0c4cc; cursor: pointer; }
	.upload img { width: 100%; height: 100%; object-fit: contain}
	
	.upload-list { width: 100%; height: auto; }
	.upload-list:after { content: ''; display: table; clear: both; }
	.upload-item { width: 120px; height: 120px; border: 1px solid #dcdfe6; border-radius: 5px; overflow: hidden; float: left; margin-top: 10px; margin-right: 10px; position: relative; }
	.upload-item img { width: 100%; margin-top: 50%; transform: translateY(-50%); }
	.upload-item-button { position: absolute; z-index: 10; left: 0; right: 0; bottom: 0; background: rgba(0,0,0,0.5); color: #ffffff; text-align: center; display: flex; height: 24px; line-height: 24px; }
	.upload-item-top { position: absolute; z-index: 10; left: 0; right: 0; top: 0; background: rgba(0,0,0,0.5); color: #ffffff; text-align: center; display: flex; height: 24px; line-height: 24px; }
	.upload-item-view,.upload-item-del,.upload-item-left,.upload-item-right { flex: 1; cursor: pointer; }
	.upload-item-del { border-left: 1px solid #ffffff; }
	.upload-item-right { border-left: 1px solid #ffffff; }
	.upload-item:hover { border-color: #409eff; }
	.upload-item:hover .upload-item-button { background: #409eff; color: #ffffff; }
	.upload-item:hover .upload-item-top { background: #409eff; color: #ffffff; }
	
	
	.upload-notice { font-size: 12px; overflow: hidden; color: #c0c4cc; }
</style>
